export default __webpack_public_path__ + "static/update0003-43456507c9b9141c5c8480e8cec061cf.png";